<span>
  <mat-icon
    [title]="percent + '%'"
    [svgIcon]="getBatteryIcon()"
    style="vertical-align: middle;"
  ></mat-icon>
  <span [class]="'battery-status-chip battery-status-' + status">
    {{ status | titlecase }}
  </span>
</span>
